/*
=========================================================
* Call It In LLC - [Component Name]
=========================================================

* Company: Call It In LLC
* Website: https://www.justcallitin.com
* Author: Shaun Matthews
* Copyright: © 2025 Call It In LLC. All rights reserved.

=========================================================
* This file is part of the Call It In dashboard system.
* Any reproduction or distribution without written consent is strictly prohibited.
=========================================================
*/


const list = {
  styleOverrides: {
    padding: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
};

export default list;
